import { FC } from 'react';
import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
} from 'react-router-dom';
import { PrivateRoute } from './components';
import {
  Login,
  Policy,
  ExpeditionCertificate,
  DamageManagement,
  ProfileSettings,
  UserSettings,
  DomesticInsurance,
  AbroadInsurance,
  MasterInsurance,
  MotorInsurance,
  OrganizationSettings,
  ResetPassword,
  Individuals,
  Dependents,
  Policies,
  TravelHealthInsurance,
  Reconciliation,
} from './pages';
import WithAuthorization from './WithAuthorization';

const App: FC = () => {
  const router = createBrowserRouter([
    {
      path: 'login',
      element: <Login />,
    },
    {
      path: 'reset-password',
      element: <ResetPassword />,
    },
    {
      path: '/',
      element: <PrivateRoute />,
      children: [
        {
          path: 'freight-insurance',
          children: [
            {
              path: 'policy',
              element: (
                <WithAuthorization model="transportationpolicy">
                  <Policy />
                </WithAuthorization>
              ),
            },
            {
              path: 'expedition-certificate',
              element: (
                <WithAuthorization model="expeditioncertificate">
                  <ExpeditionCertificate />
                </WithAuthorization>
              ),
            },
          ],
        },
        {
          path: 'damage-management',
          element: (
            <WithAuthorization model="damagemanagement">
              <DamageManagement />
            </WithAuthorization>
          ),
        },
        {
          path: 'reconciliation',
          element: (
            <WithAuthorization model="reconciliation">
              <Reconciliation />
            </WithAuthorization>
          ),
        },
        {
          path: 'main-insurances',
          children: [
            {
              path: 'domestic-insurance',
              element: (
                <WithAuthorization model="domesticinsurance">
                  <DomesticInsurance />
                </WithAuthorization>
              ),
            },
            {
              path: 'abroad-insurance',
              element: (
                <WithAuthorization model="abroadinsurance">
                  <AbroadInsurance />
                </WithAuthorization>
              ),
            },
            {
              path: 'master-insurance',
              element: (
                <WithAuthorization model="otherinsurance">
                  <MasterInsurance />
                </WithAuthorization>
              ),
            },
          ],
        },
        {
          path: 'user-profiles-and-authorisation',
          children: [
            {
              path: 'profile-settings',
              element: (
                <WithAuthorization model="extendedgroup">
                  <ProfileSettings />
                </WithAuthorization>
              ),
            },
            {
              path: 'user-settings',
              element: (
                <WithAuthorization model="user">
                  <UserSettings />
                </WithAuthorization>
              ),
            },
            {
              path: 'organization-settings',
              element: (
                <WithAuthorization model="organization">
                  <OrganizationSettings />
                </WithAuthorization>
              ),
            },
          ],
        },
        {
          path: 'group-health-insurance',
          children: [
            {
              path: 'individuals',
              element: (
                <WithAuthorization model="grouphealthinsuranceindividuals">
                  <Individuals />
                </WithAuthorization>
              ),
            },
            {
              path: 'dependents',
              element: (
                <WithAuthorization model="grouphealthdependent">
                  <Dependents />
                </WithAuthorization>
              ),
            },
            {
              path: 'policies',
              element: (
                <WithAuthorization model="grouphealthinsurancepolicies">
                  <Policies />
                </WithAuthorization>
              ),
            },
          ],
        },
        {
          path: 'travel-health-insurance',
          element: (
            <WithAuthorization model="travelhealthinsurance">
              <TravelHealthInsurance />
            </WithAuthorization>
          ),
        },
        {
          path: 'motor-insurance',
          element: (
            <WithAuthorization model="motorinsurance">
              <MotorInsurance />
            </WithAuthorization>
          ),
        },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/" replace />,
    },
  ]);

  return (
    <div>
      <RouterProvider router={router} />
    </div>
  );
};

export default App;
